import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

// Menu
export interface Menu {
	path?: string;
	title?: string;
   type?: string;
   icon?:string;
	badgeType?: string;
	badgeValue?: string;
   active?: boolean;
   megaMenu?: boolean;
   megaMenuType?: string; // small, medium, large
	bookmark?: boolean;
   children?: Menu[];
   id?: string,
   fragment?: string
}

@Injectable({
  providedIn: 'root'
})
export class NavService {

   public MENUITEMS: Menu[] = [
    //  {
    // 		title: 'Home', type: 'sub', children: [
    //          { path: '/agency', title: 'Agency', type: 'link' },
    // 			{ path: '/enterprice', title: 'App Landing1', type: 'link' },
    //          { path: '/modern', title: 'App Landing2', type: 'link', },
    //          { path: '/event', title: 'Event', type: 'link' },
    //          { path: '/gym', title: 'Gym', type: 'link' },
    //          { path: '/music', title: 'Music', type: 'link' }, 
    //          { path: '/resume', title: 'Resume', type: 'link' },
    //          { path: '/enterprice-sass', title: 'Sass1', type: 'link' },
    // 			{ path: '/modern-sass', title: 'Sass2', type: 'link' },
    //          { path: '/wedding', title: 'Wedding', type: 'link'},
    //          { path: '/yoga', title: 'Yoga', type: 'link'},
    //          { path: '/portfolio-layout', title: 'Portfolio', type: 'link' },
    //          { path: '/e-commerce', title: 'E-commerce', type: 'link' },
    // 		],
    //  },
    ]

    // Array
    public items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
   

   constructor(
      private translateService: TranslateService
   ) { 
      this.initializeContent()
      this.translateService.onLangChange.subscribe(data => {
         this.initializeContent()
      })
   }

   initializeContent() {
      this.translateService.getTranslation(this.translateService.currentLang).subscribe(data => {
         this.MENUITEMS = [
            { title: data['Nav']['Home'], type: 'link', path: '/', fragment: 'introduction' },
            { title: data['Nav']['OurServices'], type: 'link', path: '/', fragment: 'our-services' },
            { title: data['Nav']['OurTerritory'], type: 'link', path: '/', fragment: 'our-territory' },
            { title: data['Nav']['OurAchievements'], type: 'link', path: '/', fragment: 'our-achievements' },
            { title: data['Nav']['MeetOurExpert'], type: 'link', path: '/', fragment: 'meet-our-expert' },
            // { title: data['Nav']['E-Access'], type: 'link', path: '/', fragment: 'E-Access' },
            // { title: data['Nav']['Blog'], type: 'extLink', path: '/blog' },
         ]
         this.items = new BehaviorSubject<Menu[]>(this.MENUITEMS)
      })
   }
   
}
